<template>
  <div class="width-100p">
    <v-dialog
      v-model="dialog"
      content-class="crud-dialog"
      persistent
      max-width="400px"
    >
      <template #activator="{ on }">
        <v-btn depressed large block color="white" class="ma-0" v-on="on">
          Mark as do not contact
        </v-btn>
      </template>

      <v-card class="crud-card">
        <v-card-title class="crud-card-title">
          <v-row no-gutters>
            <v-col cols="11">
              <h2 class="text-h5">Mark as do not contact</h2>
            </v-col>
            <v-col cols="1">
              <v-icon
                class="modal-close"
                color="black"
                @click.stop="closeDialog"
                >{{ icons.mdiClose }}</v-icon
              >
            </v-col>
          </v-row>
        </v-card-title>

        <v-divider />

        <v-card-text class="crud-card-text">
          <p>
            Are you sure you want to mark <b>{{ testatorName }}</b> as do not
            contact?
          </p>
        </v-card-text>

        <v-card-actions class="crud-card-actions">
          <v-row no-gutters>
            <v-col cols="12">
              <v-btn
                rounded
                depressed
                :loading="buttonLoading"
                color="primary"
                class="left-edit-btn"
                @click="markAsDoNotContact()"
              >
                <span>Yes, Mark as do not contact</span>
                <v-icon small>{{ icons.mdiArrowRight }}</v-icon>
              </v-btn>

              <v-btn
                class="right-edit-btn"
                rounded
                depressed
                outlined
                color="grey.darken1"
                @click="closeDialog()"
              >
                Cancel
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ErrorSnackbar v-model="showError" />
  </div>
</template>

<script>
  import ErrorSnackbar from '../../common/ErrorSnackbar.vue';
  import { formHelperMixin } from '../../../mixins/form-helper-mixin';
  import { MARK_TESTATOR_DO_NOT_CONTACT_MUTATION } from '../../../constants/graphql/testators';

  export default {
    name: 'doNotContactTestator',
    components: {
      ErrorSnackbar,
    },
    mixins: [formHelperMixin],
    props: {
      testator: {
        required: true,
        type: Object,
      },
      referrerRoute: {
        type: String,
        default: 'AdminPage',
      },
      referrerId: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        dialog: false,
        successMessage: null,
      };
    },
    computed: {
      testatorName() {
        return this.testator.fullName
          ? this.testator.fullName
          : this.testator.email;
      },
      isAdmin() {
        return this.$store.getters.isAdmin;
      },
    },
    methods: {
      markAsDoNotContact() {
        const id = this.testator.id;
        this.$apollo
          .mutate({
            mutation: MARK_TESTATOR_DO_NOT_CONTACT_MUTATION,
            variables: {
              id,
            },
          })
          .then(response => {
            if (response.data.doNotContactTestator.success) {
              this.successMessage =
                'User successfully marked as do not contact';
              this.redirect();
            } else {
              this.displayErrorAndCloseDialog();
            }
          })
          .catch(error => {
            this.displayErrorAndCloseDialog();
            throw error;
          });
      },
      redirect() {
        this.$router.push({
          name: this.referrerRoute,
          params: { id: this.referrerId, successMessage: this.successMessage },
        });
      },
      closeDialog() {
        this.dialog = false;
        this.buttonLoading = false;
      },
    },
  };
</script>
